<template>
    <!-- <div class="row align-self-center">
        <div class="col" @click="retry()">
            <b-spinner variant="primary" label="Loading..." style="width: 3rem; height: 3rem;" :class="{'hide':!this.loading || this.offline}"></b-spinner>
            <img :class="{'hide':!this.offline}" src="../assets/img/offline3.svg" style="width:6rem;height:6rem;"/>
            <div class="w-100"></div>
            <h5 class="text-center text-danger" :class="{'hide':!this.offline}">请重试</h5>
        </div>
    </div> -->
    <b-row align-v="center">
        <b-col @click="retry()">
            <b-spinner variant="primary" label="Loading..." style="width: 3rem; height: 3rem;" :class="{'hide':!this.loading || this.offline}"></b-spinner>
            <img :class="{'hide':!this.offline}" src="../assets/img/offline3.svg" style="width:6rem;height:6rem;"/>
            <div class="w-100"></div>
            <h5 class="text-center text-danger" :class="{'hide':!this.offline}">请重试</h5>
        </b-col>
    </b-row>
</template>

<style scoped>
    div.col img,div.col h5{
        cursor: pointer;
    }
</style>

<script>
export default {
    name:'loadingSpinner',
    props:['loading','offline'],
    methods:{
        retry:function(){
            this.$emit('retry-action');
        }
    }
}
</script>

